/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { SearchAIAnswerStream, SearchAIRecommendedQuestionStream, SiteSearchScope } from "./data-contracts";

/**
 * @description The response is streamed.
 * @tags site-ask
 * @name StreamAskInSite
 * @summary Ask a question in a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/ask
 * @secure
 */

// @ts-ignore
export const streamAskInSite: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: true;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
  };
  RequestBody: {
    /** @maxLength 512 */
    question: string;
    /** You may optionally provide additional information about the context of the question. This doesn't affect the scope of the search, but GitBook may use this information to provide a better answer. Generally speaking, you should provide as much context as possible. */
    context?: {
      siteSpaceId?: string;
    };
    scope: SiteSearchScope;
  };
  RequestHeaders: {};
  ResponseBody: SearchAIAnswerStream;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/ask",
  method: "post",
  streaming: true,
  tags: ["site-ask"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description The response is streamed.
 * @tags site-ask
 * @name StreamRecommendedQuestionsInSite
 * @summary List recommended questions to ask in a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/ask/questions
 * @secure
 */

// @ts-ignore
export const streamRecommendedQuestionsInSite: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: true;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** The ID of the site space to filter the recommended questions for. */
    siteSpaceId?: string;
    /**
     * The ID of the space to filter the recommended questions for.
     * @deprecated
     */
    spaceId?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SearchAIRecommendedQuestionStream;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/ask/questions",
  method: "get",
  streaming: true,
  tags: ["site-ask"],
  criticalityLevel: "low",
  deprecated: false,
};
